import { getProductScope } from '@discover-frontend/utils';
import { callApi } from './api';

export const fetchTimeframes = () =>
  callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/timeframes?scope=${getProductScope()}`,
    mock: false,
  });

export const fetchQueryItemsMetadata = (ids, sources) =>
  callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/variables/metadata?ids=${ids}&scope=${getProductScope()}&sources=${sources}`,
    mock: false,
  });

export const fetchReportErrorApi = (id, body) =>
  callApi({
    api: 'ENGINE',
    method: 'POST',
    endpoint: `/reporting/items/${id}`,
    mock: false,
    body,
  });

export const fetchDemographicsApi = (sources) =>
  callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/variables/demographics?scope=${getProductScope()}&sources=${sources}`,
    mock: false,
  });

export const fetchExploreItemsApi = (queryString) => {
  const params =
    queryString === ''
      ? `?scope=${getProductScope()}`
      : `${queryString}&scope=${getProductScope()}`;
  return callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/variables/search${params}`,
    mock: false,
  });
};

export const fetchExploreItemsInTaxonomyApi = (queryString) =>
  callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/variables/search${queryString}`,
    mock: false,
  });

export const fetchTaxonomyApi = (types, sources) =>
  callApi({
    api: 'ENGINE',
    method: 'GET',
    endpoint: `/taxonomy?types=${types}&scope=${getProductScope()}&sources=${sources}`,
    mock: false,
  });

export const fetchRequireMissingItemApi = (body) =>
  callApi({
    api: 'ENGINE',
    method: 'POST',
    endpoint: `/reporting/items`,
    mock: false,
    body,
  });

export const fetchRecentConversationsApi = () =>
  callApi({
    api: 'AFFINITY',
    method: 'GET',
    endpoint: `/conversations/recent?scope=${getProductScope()}`,
    mock: false,
  });

export const fetchPostRecentConversationsApi = (body) =>
  callApi({
    api: 'AFFINITY',
    method: 'POST',
    endpoint: `/conversations/recent`,
    mock: false,
    body,
  });

export const fetchMembershipApi = (body) =>
  callApi({
    api: 'QUERY_MEMBERSHIP',
    method: 'POST',
    endpoint: `/size`,
    mock: false,
    body,
  });
